export const GooglePayView = () => {
    // just a placeholder component for now. Feel free to extend it if you need more details for the apple pay view.
    return null;
};
